module.exports = __webpack_public_path__ + "static/media/my-hover.3210f15d.png";